import { useEffect } from 'react';
import { useGameStore } from '../simulation/store';

const TICK_MS = 250;
const BASE_DELTA_MINUTES = 2.4;

export function useSimulationEngine(): void {
  const tick = useGameStore((state) => state.tick);

  useEffect(() => {
    const id = window.setInterval(() => {
      tick(BASE_DELTA_MINUTES);
    }, TICK_MS);

    return () => {
      window.clearInterval(id);
    };
  }, [tick]);
}
